import {
  getFullAttraction,
} from '@/calls/event';
import {
  requestStock,
  getOrder,
  resetOrder,
  confirmOrder,
  initPayment,
  getStatus,
  sendMollieToOrder
} from '@/calls/basket';
import router from '@/router';

const basket = {
  namespaced: true,
  state: {
    requests: 0,
    step: 0,
    status: null,
    message: null,
    error: null,
    attraction: {
      id: null,
      item: null,
      events: []
    },
    datas: {
      event: null,
      date: null,
      orderid: null,
      order: null,
      tickets: []
    },

    infos: {
      policy: {
        privacy: false,
        age: false
      }
    }
  },
  mutations: {
    setId(state, id) {
      state.attraction.id = id;
      localStorage.setItem('basketAttraction', id);
    },
    setAttraction(state, attraction) {
      state.attraction.item = attraction;
    },
    setError(state, error) {
      state.error = error;
    },
    increaseRequests(state) {
      state.requests += 1;
    },
    decreaseRequests(state) {
      state.requests -= 1;
    },
    setEvent(state, id) {
      if (!id) {
        state.datas.event = null;
        return;
      }

      const event = state.attraction.item.events.filter(e => e.id === id);
      // eslint-disable-next-line
      state.datas.event = event[0];
    },
    setDate(state, date) {
      state.datas.date = date;
    },
    setOrder(state, order) {
      state.datas.order = order;
    },
    setOrderId(state, id) {
      state.datas.orderid = id;

      if (id) {
        localStorage.setItem('orderID', id);
      }
    },
    updateInfo(state, { type, value }) {
      state.infos[type] = value;
    },
    updatePolicy(state, { type, value }) {
      state.infos.policy[type] = value;
    },
    updateCredit(state, { type, value }) {
      state.infos.credit[type] = value;
    },
    resetTickets(state) {
      state.datas.tickets = [];
    },
    removeTicket(state, ticket) {
      const tick = state.datas.tickets.filter(t => t.id === ticket.id && t.categoryid === ticket.categoryid);

      if (tick.length > 0) {
        const t = tick[0];

        if (t.quantity === t.quantity_min + 1) {
          const index = state.datas.tickets.indexOf(t);
          state.datas.tickets.splice(index, 1);
        } else {
          t.quantity -= 1;
        }
      }
    },
    addTicket(state, ticket) {
      const tick = state.datas.tickets.filter(t => t.id === ticket.id && t.categoryid === ticket.categoryid);

      if (tick.length > 0) {
        const t = tick[0];
        if (t.quantity < t.quantity_max) {
          t.quantity += 1;
        }
        return;
      }

      state.datas.tickets.push({
        ...ticket,
        quantity: ticket.quantity_min !== 0 ? ticket.quantity_min : 1
      });
    },
    setStatus(state, status) {
      state.status = status;
    },
    setMessage(state, message) {
      state.message = message;
    }
  },
  actions: {
    async getAttraction({ commit }, id) {
      commit('increaseRequests');
      commit('setId', id);

      const request = await getFullAttraction(id);

      if (request.success) {
        commit('setAttraction', request.data);

        if (request.data.events && request.data.events.length === 1) {
          commit('setDate', {
            label: request.data.events[0].date,
            value: request.data.events[0].id
          });
          commit('setEvent', request.data.events[0].id);

          if (request.data.stream) {
            const event = request.data.events[0];
            const { products } = event;
            const category = products.categories[0];

            if (category) {
              const price = category.prices[0];

              if (price) {
                commit('addTicket', price);
              }
            }
          }
        }
      }

      commit('decreaseRequests');
    },
    async requestStock({ state, commit, dispatch }, redirect = false) {
      commit('increaseRequests');

      const requests = state.datas.tickets.map(t => {
        const req = {
          quantity: t.quantity,
          categoryid: t.categoryid,
          stockid: t.stockid,
          priceid: t.id
        };

        if (state.datas.orderid) {
          req.orderid = state.datas.orderid;
        }

        return req;
      });

      const request = await requestStock(requests);

      if (request.success) {
        const { data } = request;

        if (data.orderid) {
          commit('setOrderId', data.orderid);
        }

        if (redirect) {
          router.push({ name: 'BasketPlaces' });
          dispatch('getOrder');
        }
      }

      commit('decreaseRequests');
    },
    async getOrder({ state, commit }, id) {
      commit('increaseRequests');

      if (id) {
        commit('setOrderId', id);
      }

      const request = await getOrder(state.datas.orderid);

      if (request.success) {
        const { data } = request;
        commit('setOrder', data);

        if (data.event) {
          commit('setDate', data.event);
          commit('setEvent', data.event.value);
        }
      }

      commit('decreaseRequests');
    },
    async resetOrder({ state, commit }) {
      commit('increaseRequests');
      // eslint-disable-next-line
      const request = await resetOrder(state.datas.orderid);
      commit('decreaseRequests');
    },
    async confirmOrder({ rootState, state, commit }) {
      commit('increaseRequests');
      commit('setError', null);

      const request = await confirmOrder({
        orderid: state.datas.orderid,
        contactid: rootState.profile.infos.id
      });

      if (request.success) {
        if (request.data) {
          if (request.data.status.id === 1 || request.data.status.id === 15 || request.data.status.id === 20) {
            commit('decreaseRequests');
            return 'paid';
          }

          commit('decreaseRequests');
          return true;
        }

        if (request.error && request.error.code === 1000) {
          commit('decreaseRequests');
          return true;
        }
      } else {
        commit('setError', 'Une erreur est survenue lors de la confirmation de la commande. Veuillez réessayer.');
        // commit('setError', 'Une erreur est survenue dans la confirmation. Il se peut que les places aient été réattribués car trop de temps s\'est écoulé entre la réservation et la confirmation. Veuillez réessayer.');
      }

      commit('decreaseRequests');
      return null;
    },
    async pay({ dispatch, commit, state }) {
      commit('increaseRequests');
      localStorage.removeItem('mollie_checkout_id');

      const confirm = await dispatch('confirmOrder');

      if (confirm) {
        if (confirm === 'paid') {
          localStorage.setItem('orderStatus', state.datas.orderid);
          localStorage.setItem('mollie_checkout_id', 'paid');
          commit('setMessage', 'paid');
          commit('setStatus', 'success');
          commit('decreaseRequests');

          if (state.attraction.item && state.attraction.item.stream) {
            router.push({ name: 'BasketMessage', query: { stream: 'true' } });
            return;
          }

          router.push({ name: 'BasketMessage' });
          return;
        }

        let total = 0;

        state.datas.order.tickets.map(t => {
          total += t.price.value;
        });

        const request = await initPayment({
          orderid: state.datas.orderid,
          // ORDERXXXXX
          description: state.datas.order.label,
          total,
          stream: state.attraction.item && state.attraction.item.stream
        });

        if (request.success) {
          const req = await sendMollieToOrder({
            mollieID: request.data.payment_id,
            orderID: state.datas.orderid
          });

          if (req.success) {
            localStorage.setItem('orderStatus', state.datas.orderid);
            localStorage.setItem('mollie_checkout_id', request.data.payment_id);
            commit('setMessage', null);
            window.location = request.data.checkout_url;
          }
        }
      }

      commit('decreaseRequests');
    },
    async getStatus({ commit }, ids) {
      commit('increaseRequests');

      if (ids.mollieID && ids.mollieID === 'paid') {
        commit('setStatus', 'success');
        commit('decreaseRequests');
        return;
      }

      const request = await getStatus(ids);

      if (request.success) {
        const { data } = request;

        switch (true) {
          case data.error:
            commit('setStatus', 'error');
            break;
          case data.canceled:
            commit('setStatus', 'canceled');
            break;
          case data.complete:
            commit('setStatus', 'success');
            break;
          default:
            commit('setStatus', 'waiting');
            break;
        }
      }

      commit('decreaseRequests');
    },
    reset({ commit }) {
      commit('setAttraction', null);
      commit('setEvent', null);
      commit('setOrder', null);
      commit('setOrderId', null);
      commit('setDate', null);
      commit('resetTickets');
      localStorage.removeItem('basketAttraction');
      localStorage.removeItem('orderID');
    }
  }
};

export default basket;
